export function useProducts() {
	const scrollToContactForm = () => {
		const contactForm = document.getElementById("contact-form");
		contactForm.scrollIntoView({
			behavior: "smooth",
			block: "center",
		});
	};

	return {
		scrollToContactForm,
	};
}
